import React, { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { getLocal } from "../../../helpers/Local";
import { add_plan_me, changeTab, selectPatient, setPatientSnapshotData } from "../../../store/actions";
import ScrollWrapper from "../ScrollBar";
import "./style.scss";

const ExtendDataTableNew = ({
  title,
  data,
  ListActiveHover,
  ListActiveHover2,
  disableHeader,
  options,
  widths,
  minRows,
  onClickRow,
  onClickColumn,
  isActiveBorder = false,
  activeRow,
  isBorderOnHover,
  isBorderLeftNone,
  isBorderThick,
  highlights,
}) => {
  const dispatch = useDispatch();
  const [activeIndex, setActive] = useState(-1);
  const patient_id = getLocal("current_patient_id");
  const emptyRows = useMemo(() => {
    const rowCount = minRows ? minRows : 8;
    if (data && data.length) {
      const numberOfRows = data.length > rowCount ? 0 : rowCount - data.length;
      return new Array(numberOfRows).fill("empty");
    }
    return new Array(rowCount).fill("empty");
  }, [data]);
  const handle_action = async (row) => {
    const result = await dispatch(selectPatient(patient_id));
    await dispatch(setPatientSnapshotData("resource", { ...result }));
    if (row["tab"] && row["tab"] == "plan_order") {
      const save_success = await dispatch(
        add_plan_me(row["appointment_id"] ? row["appointment_id"] : "", {
          meaningful_use_id: row["id"] ? row["id"] : "",
        })
      );
      if (save_success && save_success.result && save_success.result == true) {
        await dispatch(
          changeTab({
            tabActive: row["tab"] ? row["tab"] : "",
            accordion: row["accordion"] ? row["accordion"] : "",
            step: row["step"] ? row["step"] : "",
          })
        );
      }
    } else {
      await dispatch(
        changeTab({
          tabActive: row["tab"] ? row["tab"] : "",
          accordion: row["accordion"] ? row["accordion"] : "",
          step: row["step"] ? row["step"] : "",
        })
      );
    }
  };

  // useEffect(() => {
  //   if (activeRow === -1) {
  //     setActive(-1);
  //   } else {
  //     setActive(activeRow);
  //   }
  // }, [activeRow]);

  return (
    <div className="subDataTable" style={{ height: "100%" }}>
      {!disableHeader && (
        <div
          className="subDataTable__title"
          style={{
            padding: "0",
            ...(isBorderLeftNone && { borderLeft: "none", borderRight: "none" }),
            ...(isBorderThick && { borderBottom: "2px solid #dfe3e6" }),
          }}
        >
          {title}
        </div>
      )}
      <div
        style={{
          height: "calc(44vh)",
          borderTop: 0,
        }}
      >
        <ScrollWrapper css="x-hidden zero-padding">
          {(data || []).map((row, index) => {
            const activeList = (ListActiveHover || []).find((r) => r?.vessel == row?.key);
            const activeList2 = (ListActiveHover2 || []).find((r) => r?.vessel == row?.key);
            return (
              <div
                className={`subDataTable__item ${activeList?.hoverActive ? "active" : ""} ${activeList2?.hoverActive ? "active-hover2" : ""} ${
                  row.row_color_status ? row.row_color_status : ""
                }`}
                key={`item-${row.item}-${index}-${row.key}`}
                style={{
                  minHeight: 120,
                  height: "auto",
                  borderLeft: "1px solid #dbe3ee",
                  borderRight: "1px solid #dbe3ee",
                  borderBottom: "1px solid #dbe3ee",
                  borderTop: "none",
                }}
              >
                {(options || []).map((keyOption, index) => {
                  if (keyOption !== "vessel") {
                    return (
                      <div
                        key={keyOption}
                        style={{
                          width: "100%",
                          maxWidth: `${widths[index]}`,
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          paddingRight: "1px",
                        }}
                        onClick={() => {
                          if (onClickColumn) {
                            onClickColumn(index);
                          }
                        }}
                      >
                        {row[keyOption]}
                      </div>
                    );
                  }
                  return (
                    <span
                      key={keyOption}
                      style={{
                        width: "100%",
                        maxWidth: `${widths[index]}`,
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        paddingRight: "1px",
                      }}
                      onClick={() => {
                        if (onClickColumn) {
                          onClickColumn(index);
                        }
                      }}
                    >
                      {row[keyOption] || row["name"]}
                    </span>
                  );
                })}
              </div>
            );
          })}
        </ScrollWrapper>
      </div>
    </div>
  );
};

export default ExtendDataTableNew;
